import styled from 'styled-components';

export const StyledNameContainer = styled.div`
    display: flex;
    margin-left: 10px;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    @media (max-width: 768px) {
        /* flex-direction: column; */
        margin: 0px;
    }
`;

export const StyledInsuranceImage = styled.img`
    overflow: hidden;
    height: 90px;
    width: 90px;
    max-height: 90px;
    max-width: 90px;
    min-height: 90px;
    min-width: 90px;
`;
export const StyledInsuranceNameContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    margin-left: 16px;
`;
export const StyledInsuranceName = styled.div<{
    $color: string;
}>`
    max-width: 400px;
    color: ${(p) => (p.$color === 'white' ? p.theme.colors.white : p.theme.colors.beyondGrey)};
    font-size: ${(p) => p.theme.fontSizes.heading};
    font-style: normal;
    font-weight: 500;
    line-height: 28px;
    text-align: center;
    letter-spacing: -0.02em;
`;

export const StyledInsuranceCategory = styled.div<{
    $color: string;
}>`
    color: ${(p) => (p.$color === 'white' ? p.theme.colors.white : p.theme.colors.beyondGrey)};
    font-size: ${(p) => p.theme.fontSizes.body};
    margin-top: 8px;
    font-weight: 600;
    font-style: normal;
    font-weight: 400;
`;
